// import React from 'react'
// import Verticals from '../../Components/Home/Verticals'
// import RoadMap from '../../Components/Home/RoadMap'
// import { PlayProvider } from '../../Components/Home/contexts/Play'
// import FadeInSectionDownToUp from '../../Components/FadeAnimations/FadeInSectionDownToUp'

// export default function Home() {
//     return (
//         <div>
//             <div className=''>
//                 <div className="relative w-full h-screen overflow-hidden">
//                     {/* Background Video */}
//                     <video
//                         className="absolute inset-0 w-full h-full object-cover"
//                         src="https://albidayahgroups.com/Media/Videos/intro%20v2.mp4"
//                         autoPlay
//                         muted
//                         loop
//                         playsInline
//                     />

//                     {/* Dark Overlay */}
//                     <div className="absolute inset-0 bg-black bg-opacity-60 mix-blend-multiply"></div>

//                     {/* Centered Text Overlay */}
//                     <div className="relative z-10 flex items-center justify-center h-full px-6 md:px-16 text-center">
//                         <div className="text-white">
//                             <FadeInSectionDownToUp>
//                                 <h1 className='text-4xl font-[cursive]'>Welcome to RAB</h1>
//                                 <h2 className="text-6xl max-sm:text-4xl font-bold mb-4 leading-tight">
//                                     Rooted in <span className='text-yellow-500'>Trust,</span><br />
//                                     Driven by Purpose
//                                 </h2>
//                                 <p className="text-lg md:text-xl max-w-xl mx-auto">
//                                     Explore our journey, discover our achievements, and see how our passion,
//                                     innovation, and commitment continue to shape a better future.
//                                 </p>
//                             </FadeInSectionDownToUp>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div>
//                 <Verticals />
//             </div>
//             <div style={{ width: '100vw', height: '100vh' }}>
//                 <PlayProvider>
//                     <RoadMap />
//                 </PlayProvider>
//             </div>
//         </div>
//     )
// }




// import React, { useEffect, useRef } from 'react';
// import Verticals from '../../Components/Home/Verticals';
// import RoadMap from '../../Components/Home/RoadMap';
// import { PlayProvider } from '../../Components/Home/contexts/Play';
// import FadeInSectionDownToUp from '../../Components/FadeAnimations/FadeInSectionDownToUp';
// import Marquee from 'react-fast-marquee';

// export default function Home() {
//     const roadmapRef = useRef(null);

//     useEffect(() => {
//         const observer = new IntersectionObserver(
//             ([entry]) => {
//                 if (entry.isIntersecting && entry.intersectionRatio > 0.01) {
//                     // Scroll the section into full view
//                     roadmapRef.current.scrollIntoView({
//                         behavior: 'smooth',
//                         block: 'start',
//                     });
//                 }
//             },
//             {
//                 threshold: [0.2], // Trigger when just 1% of the section is visible
//             }
//         );

//         const refCurrent = roadmapRef.current;
//         if (refCurrent) {
//             observer.observe(refCurrent);
//         }

//         return () => {
//             if (refCurrent) observer.unobserve(refCurrent);
//         };
//     }, []);

//     const achievementFrames = Array.from({ length: 12 }, (_, i) => {
//         const index = (i + 1).toString().padStart(2, "0"); // ensures 01, 02, ..., 12
//         return `https://albidayahgroups.com/Media/Home/FRAME%20${index}.png`;
//     });

//     return (
//         <div className="overflow-x-hidden">
//             {/* Hero Section */}
//             <section className="relative w-full h-screen">
//                 <video
//                     className="absolute inset-0 w-full h-full object-cover"
//                     src="https://albidayahgroups.com/Media/Videos/intro%20v2.mp4"
//                     autoPlay
//                     muted
//                     loop
//                     playsInline
//                 />
//                 <div className="absolute inset-0 bg-black bg-opacity-60 mix-blend-multiply" />
//                 <div className="relative z-10 flex items-center justify-center h-full px-6 md:px-16 text-center">
//                     <div className="text-white">
//                         <FadeInSectionDownToUp>
//                             <h1 className="text-3xl font-semibold">AL-BIDAYAH Welcomes You</h1>
//                             <h2 className="text-6xl max-sm:text-4xl font-bold mb-4 leading-tight">
//                                 Rooted in <span className="text-yellow-500">Trust,</span><br />
//                                 Driven by Purpose
//                             </h2>
//                             <p className="text-lg md:text-xl max-w-xl mx-auto">
//                                 Explore our journey, discover our achievements, and see how our passion,
//                                 innovation, and commitment continue to shape a better future.
//                             </p>
//                         </FadeInSectionDownToUp>
//                     </div>
//                 </div>
//             </section>

//             <div>
//                 {/* <div className='bg-[#420110] rounded-3xl flex justify-between items-center px-20 py-10 mx-20 my-10'>
//                     <div className='text-white w-full'>
//                         <FadeInSectionDownToUp>
//                             <p className='text-3xl font-bold pb-5'>Who we are?</p>
//                             <p className='text-xl text-justify'>
//                                 Founded in Malaysia and cherished globally, Restoran AL-BIDAYAH
//                                 has been delighting taste buds with its authentic regional delicacies
//                                 since 1996. With more than a dozen outlets across Malaysia and a
//                                 growing presence in Singapore, Dubai, and Saudi Arabia, we take
//                                 immense pride in being a global ambassador for Malaysia’s rich
//                                 culinary heritage. Offering an array of traditional favourites, we are
//                                 committed to bringing the essence of local flavours to the world,
//                                 available around the clock for your enjoyment.
//                             </p>
//                         </FadeInSectionDownToUp>
//                     </div>
//                     <div className='w-full'>
//                         <img className='' src='https://albidayahgroups.com/Media/RAB.png' alt='AL-BIDAYAH' />
//                     </div>
//                 </div> */}

//                 <div
//                     className="bg-[#420110] rounded-3xl flex max-sm:flex-col justify-between items-center px-20 xl:px-20 sm:px-10 max-sm:px-5 xl:py-0 sm:py-10 max-sm:py-10 mx-20 max-sm:mx-5 my-10 relative overflow-hidden"
//                     style={{
//                         backgroundImage: `url('https://albidayahgroups.com/Media/Home/Frame%20314041.png')`,
//                         backgroundPosition: "left bottom",
//                         backgroundRepeat: "no-repeat",
//                         backgroundSize: "auto 50%", // Show only 10% of height
//                     }}
//                 >
//                     <div className="text-white w-full z-10">
//                         <FadeInSectionDownToUp>
//                             <p className="text-3xl font-bold">Who we are?</p>
//                             <p className="text-xl text-justify">
//                                 Founded in Malaysia and cherished globally, Restoran AL-BIDAYAH
//                                 has been delighting taste buds with its authentic regional delicacies
//                                 since 1996. With more than a dozen outlets across Malaysia and a
//                                 growing presence in Singapore, Dubai, and Saudi Arabia, we take
//                                 immense pride in being a global ambassador for Malaysia’s rich
//                                 culinary heritage. Offering an array of traditional favourites, we are
//                                 committed to bringing the essence of local flavours to the world,
//                                 available around the clock for your enjoyment.
//                             </p>
//                         </FadeInSectionDownToUp>
//                     </div>
//                     <div className="w-full z-10">
//                         <img src="https://albidayahgroups.com/Media/RAB.png" alt="AL-BIDAYAH" />
//                     </div>
//                 </div>

//             </div>

//             <div>
//                 <div className='px-20 max-sm:px-5 py-10 max-sm:py-5'>
//                     <FadeInSectionDownToUp>
//                         <div className='text-center'>
//                             <p className='text-[#420110] text-4xl font-bold pb-5'>Our Impact</p>
//                             <p className='text-xl px-40 max-sm:px-5'>
//                                 We believe in actions that speak louder than words. Here’s a quick look at the numbers that
//                                 define our journey, success, and commitment to excellence.
//                             </p>
//                         </div>
//                     </FadeInSectionDownToUp>
//                 </div>
//             </div>

//             <div>
//                 <FadeInSectionDownToUp>
//                     <video
//                         className="w-full h-full object-cover"
//                         autoPlay
//                         muted
//                         loop
//                         playsInline
//                     >
//                         <source src="https://albidayahgroups.com/Media/Videos/Group_2.mp4" type="video/mp4" />
//                         Your browser does not support the video tag.
//                     </video>
//                 </FadeInSectionDownToUp>
//             </div>

//             {/* RoadMap - Full scroll trigger */}
//             <section ref={roadmapRef} className="h-[100vh]">
//                 <PlayProvider>
//                     <RoadMap />
//                 </PlayProvider>
//             </section>

//             <div>
//                 <div className='px-20 max-sm:px-5 py-10'>
//                     <FadeInSectionDownToUp>
//                         <div className='text-center'>
//                             <p className='text-[#420110] text-4xl font-bold pb-5'>Our Achievements</p>
//                             <p className='text-xl px-40 max-sm:px-5'>
//                                 Our achievements speak for our journey.<br className='max-sm:hidden' /> Every milestone reflects our dedication, impact, and pursuit of excellence.
//                             </p>
//                         </div>
//                     </FadeInSectionDownToUp>
//                 </div>
//                 <div className='pb-20'>
//                     <Marquee pauseOnHover>
//                         {achievementFrames.map((src, index) => (
//                             <img
//                                 key={index}
//                                 src={src}
//                                 alt={`Achievement ${index + 1}`}
//                                 className="hover:scale-110 transition-all ease-linear duration-500 mx-2 max-sm:w-60"
//                             />
//                         ))}
//                     </Marquee>
//                 </div>
//             </div>

//             {/* Verticals */}
//             <section>
//                 <Verticals />
//             </section>

//             <div>
//                 <div className='px-20 max-sm:px-5 py-10 space-y-10'>
//                     <FadeInSectionDownToUp>
//                         <div className='text-center'>
//                             <p className='text-[#420110] text-4xl font-bold pb-5'> Our Branches</p>
//                             <p className='text-xl px-40 max-sm:px-5'>
//                                 Expanding with purpose, rooted in values.
//                                 Our branches reflect our growing presence and commitment to serving communities across regions.
//                             </p>
//                             <div className='mt-5'>
//                                 <a href='/branches' className='bg-[#F3B999] p-2 rounded-3xl'>View all</a>
//                             </div>
//                         </div>
//                     </FadeInSectionDownToUp>
//                     <FadeInSectionDownToUp>
//                         <img className='px-40 max-sm:px-5' src='https://albidayahgroups.com/Media/Home/steptodown.com585126%201.png' alt='Our Branches' />
//                     </FadeInSectionDownToUp>
//                 </div>
//             </div>

//             <div className='pb-32'>
//                 <div className='px-20 max-sm:px-5 py-10'>
//                     <FadeInSectionDownToUp>
//                         <div className='text-center'>
//                             <p className='text-[#420110] text-4xl font-bold pb-5'>Our online partners</p>
//                             <p className='text-xl px-40 max-sm:px-5'>
//                                 We're proud to join hands with trusted online partners who strengthen our reach and impact.
//                             </p>
//                         </div>
//                     </FadeInSectionDownToUp>
//                 </div>
//                 <div className='flex justify-center items-center px-48 max-sm:px-5'>
//                     <div className='grid grid-cols-3 gap-5'>
//                         <div className='flex items-center w-full shadow-2xl border-2 rounded-3xl max-sm:rounded-xl p-5'>
//                             <img src='https://albidayahgroups.com/Media/Home/Grab-Logo%201.png' alt='Online Partners' />
//                         </div>
//                         <div className='flex items-center w-full shadow-2xl border-2 rounded-3xl max-sm:rounded-xl p-5'>
//                             <img src='https://albidayahgroups.com/Media/Home/FoodPanda-logo-768x390%201.png' alt='Online Partners' />
//                         </div>
//                         <div className='flex items-center w-full shadow-2xl border-2 rounded-3xl max-sm:rounded-xl p-5'>
//                             <img src='https://albidayahgroups.com/Media/Home/1656180317shopee-logo-png%201.png' alt='Online Partners' />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }




import React, { useEffect, useRef } from 'react';
import Verticals from '../../Components/Home/Verticals';
import RoadMap from '../../Components/Home/RoadMap';
import { PlayProvider } from '../../Components/Home/contexts/Play';
import FadeInSectionDownToUp from '../../Components/FadeAnimations/FadeInSectionDownToUp';
import Marquee from 'react-fast-marquee';
// import { QRCode } from 'react-qrcode-logo';

export default function Home() {
    const roadmapRef = useRef(null);
    // const qrRef = useRef(null); // For QR download

    useEffect(() => {
        if (!roadmapRef.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && entry.intersectionRatio > 0.2) {
                    roadmapRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    });
                }
            },
            {
                threshold: [0.2], // Trigger when 20% of the section is visible
            }
        );

        observer.observe(roadmapRef.current);

        return () => {
            if (roadmapRef.current) observer.unobserve(roadmapRef.current);
        };
    }, []);

    const achievementFrames = Array.from({ length: 12 }, (_, i) => {
        const index = (i + 1).toString().padStart(2, "0");
        return `https://albidayahgroups.com/Media/Home/FRAME%20${index}.png`;
    });

    // const siteURL = `${window.location.origin}`;

    return (
        <div className="overflow-x-hidden">
            {/* Hero Section */}
            <section className="relative w-full h-screen">
                <video
                    className="absolute inset-0 w-full h-full object-cover"
                    autoPlay
                    muted
                    loop
                    playsInline
                    poster='https://albidayahgroups.com/Media/Branches/Branch.jpg'
                >
                    <source src="https://albidayahgroups.com/Media/Videos/intro%20v6_5.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div className="absolute inset-0 bg-black bg-opacity-60 mix-blend-multiply" />
                <div className="relative z-10 flex items-center justify-center h-full px-6 md:px-16 text-center">
                    <div className="text-white">
                        <FadeInSectionDownToUp>
                            <h1 className="font-times font-extrabold text-8xl max-sm:text-5xl text-yellow-500 pb-5">AL-BIDAYAH</h1>
                            <h2 className="text-6xl max-sm:text-4xl font-bold mb-4 leading-tight">
                                Rooted in <span className="text-[#ea6e08]">Trust,</span><br />
                                Driven by Purpose
                            </h2>
                            <p className="text-lg md:text-2xl max-w-xl mx-auto">
                                Explore our journey, discover our achievements, and see how our passion,
                                innovation, and commitment continue to shape a better future.
                            </p>
                        </FadeInSectionDownToUp>
                    </div>
                </div>
            </section>

            {/* Who We Are Section */}
            {/* <div className="bg-[#420110] rounded-3xl flex max-sm:flex-col justify-center items-center gap-10 px-20 xl:px-20 sm:px-10 max-sm:px-5 xl:py-5 sm:py-10 max-sm:py-10 mx-40 max-sm:mx-5 my-10 relative overflow-hidden"
                style={{
                    backgroundImage: `url('https://albidayahgroups.com/Media/Home/Frame%20314041.png')`,
                    backgroundPosition: "right bottom",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "auto 50%",
                }}
            >
                <div className="text-white w-full z-10">
                    <FadeInSectionDownToUp>
                        <p className="text-3xl font-bold pb-3">Who we are?</p>
                        <p className="text-xl text-justify">
                            Founded in Malaysia and cherished globally, Restoran AL-BIDAYAH has been delighting taste buds with its authentic regional delicacies since 1996. With more than a dozen outlets across Malaysia and a growing presence in Singapore, Dubai, and Saudi Arabia, we take immense pride in being a global ambassador for Malaysia’s rich culinary heritage. Offering an array of traditional favourites, we are committed to bringing the essence of local flavours to the world, available around the clock for your enjoyment.
                        </p>
                    </FadeInSectionDownToUp>
                </div>
                <div className="w-full z-10">
                    <FadeInSectionDownToUp>
                    <img src="https://albidayahgroups.com/Media/Logo/Al%20Bidayah%20Logo.png" alt="AL-BIDAYAH" />
                    </FadeInSectionDownToUp>
                </div>
            </div> */}

            <div
                className="bg-[#420110] rounded-3xl flex max-sm:flex-col justify-center items-center gap-10 px-20 xl:px-20 sm:px-10 max-sm:px-5 xl:py-20 sm:py-10 max-sm:py-10 mx-40 xl:mx-40 sm:mx-20 max-sm:mx-5 my-10 relative overflow-hidden"
            >
                {/* Flipped background image overlay */}
                <div
                    className="absolute inset-0 bg-no-repeat bg-[length:auto_50%] bg-left-bottom scale-x-[-1] pointer-events-none z-0"
                    style={{
                        backgroundImage: `url('https://albidayahgroups.com/Media/Home/Frame%20314041.png')`,
                    }}
                />

                {/* Content layer */}
                <div className="text-white w-full z-10">
                    <FadeInSectionDownToUp>
                        <div className='space-y-5'>
                            <p className="text-5xl font-bold">Who we are?</p>
                            <p className="text-xl text-justify">
                                Founded in Malaysia and cherished globally, Restoran AL-BIDAYAH has been delighting taste buds with its authentic regional delicacies since 1996.
                            </p>
                            <p className="text-xl text-justify">
                                With more than 20+ outlets across Malaysia and a growing presence in Singapore, Dubai, and Saudi Arabia, we take immense pride in being a global ambassador for Malaysia’s rich culinary heritage.
                            </p>
                            <p className="text-xl text-justify">
                                Offering an array of traditional favourites, we are committed to bringing the essence of local flavours to the world, available around the clock for your enjoyment.
                            </p>
                        </div>
                    </FadeInSectionDownToUp>
                </div>

                <div className="w-1/2 max-sm:w-full z-10">
                    <FadeInSectionDownToUp>
                        <img
                            src="https://albidayahgroups.com/Media/Logo/RAB_logo_New.png"
                            alt="AL-BIDAYAH"
                        />
                    </FadeInSectionDownToUp>
                </div>
            </div>


            {/* Our Impact Section */}
            <div className="px-20 max-sm:px-5 py-10 max-sm:py-5">
                <FadeInSectionDownToUp>
                    <div className="text-center">
                        <p className="text-[#420110] text-5xl font-extrabold pb-5">Our Impacts</p>
                        <p className="text-xl px-40 max-sm:px-5">
                            <span className='font-semibold'>"We believe in actions that speak louder than words."</span><br /> Here’s a quick look at the numbers that define our journey, success, and commitment to excellence.
                        </p>
                    </div>
                </FadeInSectionDownToUp>
            </div>

            {/* Impact Video */}
            <FadeInSectionDownToUp>
                <video
                    className="w-full h-full object-cover"
                    autoPlay
                    muted
                    loop
                    playsInline
                >
                    <source src="https://albidayahgroups.com/Media/Videos/Web%20v4.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </FadeInSectionDownToUp>

            {/* Roadmap Section */}
            <section ref={roadmapRef} className="h-[100vh]">
                <PlayProvider>
                    <RoadMap />
                </PlayProvider>
            </section>

            {/* Our Achievements Section */}
            <div className='relative'>
                <div
                    className="absolute inset-0 bg-cover bg-center opacity-10"
                    style={{ backgroundImage: `url('https://albidayahgroups.com/Media/Restaurant/pattern%20bg.svg')` }}
                ></div>
                <div className="px-20 max-sm:px-5 py-10">
                    <FadeInSectionDownToUp>
                        <div className="text-center">
                            <p className="text-[#420110] text-5xl font-bold pb-5">Our Achievements</p>
                            <p className="text-xl px-40 max-sm:px-5">
                                Our achievements speak for our journey.<br className="max-sm:hidden" />
                                Every milestone reflects our dedication, impact, and pursuit of excellence.
                            </p>
                        </div>
                    </FadeInSectionDownToUp>
                </div>
                <div className="pb-20 over">
                    <Marquee pauseOnHover speed={100}>
                        {achievementFrames.map((src, index) => (
                            <img
                                key={index}
                                src={src}
                                alt={`Achievement ${index + 1}`}
                                className="hover:scale-105 transition-all ease-linear duration-500 mx-2 w-60 max-sm:w-40"
                            />
                        ))}
                    </Marquee>
                </div>
            </div>

            {/* Verticals Section */}
            <section>
                <Verticals />
            </section>

            {/* Branches Section */}
            <div className="relative px-20 max-sm:px-5 py-10 space-y-10">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url('https://albidayahgroups.com/Media/Home/Branch%20BG.jpeg')` }}
                ></div>
                <FadeInSectionDownToUp>
                    <div className="relative text-center">
                        <p className="text-[#420110] text-4xl font-bold pb-5">Our Branches</p>
                        <p className="text-xl px-40 max-sm:px-5">
                            Expanding with purpose, rooted in values. Our branches reflect our growing presence and commitment to serving communities across regions.
                        </p>
                        <div className="mt-5">
                            <a href="/branches" className="bg-[#F3B999] px-5 py-1 rounded-3xl">View all</a>
                        </div>
                    </div>
                </FadeInSectionDownToUp>
                <FadeInSectionDownToUp>
                    <img className="relative px-40 max-sm:px-5" src="https://albidayahgroups.com/Media/Home/map_new.png" alt="Our Branches" />
                </FadeInSectionDownToUp>
            </div>

            {/* Online Partners Section */}
            <div className="pb-32">
                <div className="px-20 max-sm:px-5 py-10">
                    <FadeInSectionDownToUp>
                        <div className="text-center">
                            <p className="text-[#420110] text-4xl font-bold pb-5">Our Online Partners</p>
                            <p className="text-xl px-40 max-sm:px-5">
                                We're proud to join hands with trusted online partners who strengthen our reach and impact.
                            </p>
                        </div>
                    </FadeInSectionDownToUp>
                </div>
                <div className="flex justify-center items-center px-96 xl:px-96 sm:px-40 max-sm:px-5">
                    <div className="grid grid-cols-3 gap-5">
                        {[
                            'Grab-Logo%201.png',
                            'FoodPanda-logo-768x390%201.png',
                            '1656180317shopee-logo-png%201.png',
                        ].map((img, idx) => (
                            <div key={idx} className="flex justify-center items-center w-full shadow-2xl border-2 rounded-2xl max-sm:rounded-xl p-5">
                                <img className='w-1/2 xl:w-1/2 sm:w-3/4 max-sm:w-3/4' src={`https://albidayahgroups.com/Media/Home/${img}`} alt="Online Partner" />
                            </div>
                        ))}
                    </div>
                </div>
                {/* QR Code with Logo */}
                {/* <section className="text-center mt-6">
                    <div className="inline-block p-4 bg-white rounded-xl">
                        <QRCode
                            ref={qrRef}
                            value="https://albidayahgroups.com/"
                            size={600}
                            // logoImage='https://albidayahgroups.com/Media/Logo/RAB_logo_New.png'
                            // logoWidth={200}
                            // logoHeight={180}
                            // logoOpacity={1}
                            // removeQrCodeBehindLogo
                            qrStyle="square"
                            eyeRadius={5}
                            ecLevel='H'
                        />
                    </div>
                </section> */}
            </div>
        </div>
    );
}
